import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { ROOT_MODAL_PRESENTATION_PROP } from 'components/Drawers/standardDrawerContract';

export const DIALOG_TYPE = 'CANCEL_TRANSACTION_RULE_DIALOG';

export const cancelTransactionRuleDialog = createAction(
  rootUiActions.createDialog.toString(),
  ({ onCancel }: { onCancel: () => void }) =>
    rootUiTypes.mkRootUiData({
      id: 'cancel-transaction-rule-dialog',
      type: DIALOG_TYPE,
      allowNesting: true,
      props: ImmutableMap({
        [ROOT_MODAL_PRESENTATION_PROP]: 'modal',
        onCancel,
      }),
    }),
);
